import { Simera } from "../../../@components/simera/simera.js";
import { naturalSort } from "../../../xconfig/utils.js";
import { IPagination } from "../Fetch.js";
import { xFetch, xget } from "../Fetchv2.js";
import { MGST } from "../schemas/mg.schema-types.js";
import { PGST } from "../schemas/pg.schema-types.js";
import { PGSchema } from "../schemas/pg.schema.js";
import { SR } from "../schemas/schemas/schema-reponses.js";

type HxAssessmentsPayload = {
	data: SR.apiv2.test.getTestsByPage[];
	folders: PGSchema.tests_folders[];
};

export class Psycho {
	private specificCache: Partial<Record<PGSchema.pages["id"], Partial<Record<string, HxAssessmentsPayload>>>> = {};
	private psycoCache: Partial<Record<PGSchema.pages["id"], HxAssessmentsPayload>> = {};

	private canUseCache(queryParams?: IPagination & { folder_id?: PGSchema.tests_folders["id"] }) {
		return queryParams?.skip == null || queryParams.skip === 0;
	}

	private getCached(pageId: PGSchema.pages["id"], queryParams?: IPagination & { folder_id?: PGSchema.tests_folders["id"] }) {
		if (!this.canUseCache(queryParams)) return;
		if (queryParams?.folder_id != null) return this.specificCache[pageId]?.[String(queryParams.folder_id)];
		if (queryParams?.limit != null) return;
		return this.psycoCache[pageId];
	}

	private setCached(pageId: PGSchema.pages["id"], payload: HxAssessmentsPayload, queryParams?: IPagination & { folder_id?: PGSchema.tests_folders["id"] }) {
		if (!this.canUseCache(queryParams)) return;
		if (queryParams?.folder_id != null) {
			this.specificCache[pageId] ??= {};
			this.specificCache[pageId]![String(queryParams.folder_id)] = payload;
			return;
		}
		if (queryParams?.limit != null) return;
		this.psycoCache[pageId] = payload;
	}

	async getHxAssessments(queryParams?: IPagination & { folder_id?: PGSchema.tests_folders["id"] }): Promise<[HxAssessmentsPayload, undefined | xFetch.xError<string>]> {
		let pgInfo = await window.app.pages.getToken();
		if (!pgInfo) return [{ data: [], folders: [] }, undefined];

		const cached = this.getCached(pgInfo.id, queryParams);
		if (cached) return [cached, undefined];

		let resp = await xget<HxAssessmentsPayload>(`/hirex/assessments`, queryParams, {
			headers: { "app-token": pgInfo?.token! }
		});
		let [tests, err] = resp;
		if (err) return [tests, err];

		if (!(await window.app.pages.validSub(PGST.products.products.psycho))) return [{ data: [], folders: [] }, undefined];

		if (pgInfo.hx_tests.length > 0) {
			tests.data = tests.data.filter(testServer => pgInfo.hx_tests.includes(testServer.type));
		} else {
			let testToRemove = [MGST.test.type.BFQ, MGST.test.type.GORDON];
			tests.data = tests.data.filter(testServer => !testToRemove.includes(testServer.type));
		}

		// Disponibilidad de prueba NEO PIR para Hirex e IDPP
		let idpp = ["-KzZYgMqxZ4T", "-N9cPkGZbj_t"];
		if (!idpp.includes(pgInfo.id)) {
			tests.data = tests.data.filter(testServer => testServer.tid != MGST.test.tid.NEO_PIR);
		}
		// hireX, HR Center, Employ One, Industria La Popular, Smart Fit, 2M Group, AirSupport Group, Pan Trillizos, Banco Cuscatlán, Feduro
		let Allowed = ["-KzZYgMqxZ4T", "-LVOhqvzBCh1", "-LkL_PUoCl-1", "-LVOd_JRKVrO", "-MjBhpQZrNBf", "-OB1aD7i5KDH", "-O9kZYODwtWP", "-OG6hIcjaNC3", "-O8bUWZoa7HF", "-OS0nP23bL2x"];
		if (!Allowed.includes(pgInfo.id)) {
			tests.data = tests.data.filter(testServer => testServer.tid != MGST.test.tid.INTEGRITYX_PRO);
		}

		if (!Simera.isSimeraID(pgInfo.id)) {
			let testToRemove = [MGST.test.type.REMOTE_READINESS];
			tests.data = tests.data.filter(testServer => !testToRemove.includes(testServer.type));
		}
		tests.data = tests.data.map(test => {
			switch (test.type) {
				case MGST.test.type.REMOTE_READINESS:
					test.title = "Remote Readiness";
					break;
				case MGST.test.type.INTEGRITYX:
					test.title = "IntegrityX";
					break;
				case MGST.test.type.INTEGRITY_PRO:
					test.title = "IntegrityX Pro";
					break;
			}
			return test;
		});

		tests.data = tests.data.sort((a, b) => naturalSort(a.title, b.title));
		this.setCached(pgInfo.id, tests, queryParams);
		return [tests, undefined];
	}
}
